<ng-diversions-cancel
  *ngIf="(store$ | async) as store"
  (cancelDiversion)="cancelDiversion($event)"
></ng-diversions-cancel>
